import { Link } from 'react-router-dom';

const footerLinks = {
  课程分类: [
    { label: 'IT编程技术', path: '/category/it-programming' },
    { label: '设计创意', path: '/category/design-creative' },
    { label: '商业管理', path: '/category/business-management' },
    { label: '语言学习', path: '/category/language-learning' },
    { label: '职业技能', path: '/category/vocational-skills' },
    { label: '资格证书', path: '/category/certification' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '常见问题', path: '/' },
    { label: '用户协议', path: '/' },
  ],
  学习资源: [
    { label: '学习文章', path: '/article/career-change-guide-2026' },
    { label: '免费试听', path: '/about' },
    { label: '学习社群', path: '/' },
    { label: '帮助中心', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                学至成
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed max-w-sm">
              学至成是领先的成人在线学习平台，致力于为职场人士提供高质量的在线课程和职业技能培训。随时随地，灵活学习，助你实现职业目标。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200" aria-label="小红书">
                <i className="ri-chat-smile-2-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="font-heading text-background-50 font-semibold mb-4 text-base">{title}</h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-sm">
            &copy; 2026 学至成. 保留所有权利.
          </p>
          <div className="flex items-center gap-6 text-sm text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}